// extracted by mini-css-extract-plugin
export default {"ringGuides":"RingGuideEdge_ringGuides__dsdR4","ring":"RingGuideEdge_ring__WQjJy","junctionDot":"RingGuideEdge_junctionDot__+Lr9q"};